<template>
  <v-container class="upOthers mb-10">
    <BackArrow />
    <div v-if="!play">
      <p class="text-body-1 text--secondary">Chargement...</p>
    </div>

    <v-row v-if="play" no-gutters>
      <v-col cols="12" sm="8" lg="9">
        <v-img height="400" :src="play.acf.image"></v-img>
        <h1
          class="text-h4 primary--text mt-8"
          v-html="play.title.rendered"
        ></h1>
        <h3 class="text-h6 secondary--text mt-2" v-html="play.acf.author"></h3>

        <v-row class="my-4">
          <v-col v-if="play.acf.information" cols="auto"
            ><v-icon>$peopleYellow</v-icon></v-col
          >
          <v-col
            v-if="play.acf.information"
            cols="auto"
            class="mr-6 primary--text font-weight-bold"
            >{{ play.acf.information }}</v-col
          >
          <v-col v-if="play.acf.create_date" cols="auto"
            ><v-icon>$dateYellow</v-icon></v-col
          >
          <v-col
            v-if="play.acf.create_date"
            cols="auto"
            class="mr-6 primary--text font-weight-bold"
            >{{ play.acf.create_date }}</v-col
          >
          <v-col v-if="play.acf.duration" cols="auto"
            ><v-icon>$clock</v-icon></v-col
          >
          <v-col
            v-if="play.acf.duration"
            cols="auto"
            class="mr-6 primary--text font-weight-bold"
            >{{ play.acf.duration }}</v-col
          >
        </v-row>

        <p class="text-body-1" v-html="play.content.rendered"></p>
        
        <!-- METTEUR EN SCENE -->
        <v-row
          class="backgroundGrey my-10"
          v-if="
            this.$route.params.type === 'spectacle' &&
              play.acf.note_dintention !== ''
          "
        >
          <v-col
            cols="3"
            class="d-flex align-center justify-center flex-column"
          >
            <div class="d-flex" v-if="real.length > 0">
              <v-avatar
                v-for="(r,i) in real"
                :key="i"
                size="80px"
                :style="i > 0 ? 'margin-left: -20px' : ''"
              >
                <v-img
                  v-if="r.acf.image"
                  :alt="`avatar - ${r.title.rendered}`"
                  :src="r.acf.image"
                ></v-img>
                <span
                  v-else
                  class="white--text text-h5"
                  v-text="r.title.rendered.slice(0, 1)"
                ></span>
              </v-avatar>
            </div>
            <span
              class="text-subtitle-2 mt-2 text-center"
              v-text="real.map(r => r.title.rendered).join(', ').replace(/,([^,]*)$/, ' et$1')"
            ></span>
            <span class="text-caption" v-text="real.length > 1 ? 'Metteurs en scène' : 'Metteur en scène'"></span>
          </v-col>
          <v-col cols="9">
            <v-row>
              <v-col cols="" class="coteMS left">
                <span class="white--text">“</span>
              </v-col>
              <v-col cols="9">
                <p class="text-body-2" v-html="play.acf.note_dintention"></p>
              </v-col>
              <v-col cols="" class="coteMS right">
                <span class="white--text">”</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- END METTEUR EN SCENE -->

        <!-- ROLES -->
        <div class="mb-10 mt-5">
          <v-row
            v-if="
              this.$route.params.type === 'spectacle' &&
                roles.length > 0
            "
          >
            <v-col cols="4">
              <h6
                class="primary--text text-subtitle-2"
                v-text="'Metteur en scène'"
              ></h6>
            </v-col>
            <v-col cols="8">
              <!-- add metteur en scene -->
              <p
                class="text-body-2"
                v-text="real.map(r => r.title.rendered).join(', ').replace(/,([^,]*)$/, ' et$1')"
              ></p>
            </v-col>
          </v-row>
          <v-row v-if="this.$route.params.type === 'spectacle'">
            <v-col v-if="roles.length > 0" cols="4">
              <h6
                class="primary--text text-subtitle-2"
                v-text="'Comédiens'"
              ></h6>
            </v-col>
            <v-col cols="8">
              <p
                class="text-body-2 mb-2"
                v-for="role in roles"
                :key="role.id"
                v-text="role.title.rendered"
              ></p>
            </v-col>
          </v-row>
          <v-row v-for="trole in play.acf.technical_roles" :key="trole.id">
            <!-- Groupe by  -->
            <v-col cols="4">
              <h6
                class="primary--text text-subtitle-2"
                v-text="trole.role_name"
              ></h6>
            </v-col>
            <v-col cols="8">
              <p class="text-body-2" v-text="trole.name"></p>
            </v-col>
          </v-row>
        </div>
        <!-- END ROLES -->

        <!-- VIDEO -->
        <div v-if="play.acf.lien_video" class="mb-10 mt-5">
          <v-responsive :aspect-ratio="16 / 9">
            <iframe
              width="100%"
              height="100%"
              :src="play.acf.lien_video"
              :title="play.title.rendered"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </div>
      </v-col>

      <!-- calendar part -->
      <v-col cols="12" sm="4" lg="3">
        <div class="stickyCalendar" v-if="dates.length > 0">
          <DateCard v-bind:calendars="dates" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { APIService } from "../../../APIService";
const apiService = new APIService();
import DateCard from "../../../components/cards/dateCard";
import BackArrow from "../../../components/backArrow";

export default {
  name: "PlayItem",

  components: {
    DateCard,
    BackArrow
  },

  data: () => ({
    play: null,
    real: [],
    roles: [],
    dates: []
  }),

  mounted() {
    apiService
      .getById(
        this.$route.params.type === "evenement" ? "wp/v2/event" : "wp/v2/plays",
        this.$route.params.id
      )
      .then(data => {
        this.play = data;
        console.log(data)
        if (data.acf.linked_real_play) {
          const linked = Array.isArray(data.acf.linked_real_play)
            ? data.acf.linked_real_play
            : [data.acf.linked_real_play]
          Promise.all(
            linked.map(r => apiService.getById(`wp/v2/staff`, typeof r === 'object' ? r.ID : r))
          ).then(responses => {
            this.real = responses
          })
        }

        if (data.acf.linked_play_roles && data.acf.linked_play_roles.length > 0) {
          Promise.all(
            data.acf.linked_play_roles.map(r => apiService.getById(`wp/v2/staff`, typeof r === 'object' ? r.ID : r))
          ).then(responses => {
            this.roles = responses
          })
        }

        let allDates = []
        apiService.getAll(`wp/v2/calendar`).then(response => {
          const calendarDate = response.filter(
            filter =>(
              filter.acf.event_source.formatted_value.post_type === data.type &&
              filter.acf.event === data.id &&
              moment(filter.acf.date_source.formatted_value, "DD/MM/YYYY HH:mm").isAfter(moment())
            )
          );
          calendarDate.map((c) => allDates.push(c))
        });

        apiService.getAll("wp/v2/programmation").then(response => {
          if (response.length > 0) {
            const programmationDate = response[0].acf.dates.filter(filter =>
              filter.link_play === data.id && moment(filter.date, "DD/MM/YYYY HH:mm").isAfter(moment())
            )
            programmationDate.map((c) => allDates.push(c))
          }

          this.dates = allDates
        });
    });
  }
};
</script>

<style lang="scss" scoped>
.coteMS {
  position: relative;
  span {
    position: absolute;
    font-family: "PT Sans";
    font-size: 9rem;
    line-height: 70px;
  }
}
.coteMS.left {
  span {
    top: 30px;
  }
}
.coteMS.right {
  span {
    bottom: -30px;
    right: 10px;
  }
}
.stickyCalendar {
  position: sticky;
  top: 80px;
}
</style>
